import type { App } from "vue"
import TqUploadFile from "./UploadFile/src/main.vue"

export const allBusinessComponents:any = {
    TqUploadFile
}
const install = (app: App) => {
    Object.keys(allBusinessComponents).forEach((componentName:any) => {
        app.component(componentName, allBusinessComponents[componentName])
    })
}


export default {
    install
}